import Vue from "vue";
import Vuex from "vuex";
// import {
// 	queryUserBaseInfo
// } from "@/api/user"
Vue.use(Vuex)

//后面 state，mutations 等可以在此页面写，也可以分到其他页面
export default new Vuex.Store({
	state: {
		roles: [],
		user: {},
		articleId:'',
		token:''
	},
	mutations: {
		SET_TOKEN: (state, remark) => {
			state.token = remark
		},
		SET_ARTICLEID: (state, remark) => {
			state.articleId = remark
		},
		SET_ROLES: (state, remark) => {
			state.roles = remark
		},
		SET_USER: (state, remark) => {
			state.user = remark
		},
	},
	getters: {

	},
	actions: {
		GetInfo({
			commit,
			state
		}) {
			return new Promise((resolve, reject) => {
				// queryUserBaseInfo().then(res => {
				// 	commit('SET_USER', res);
				// 	resolve(res)
				// }).catch(error => {
				// 	reject(error)
				// })
			})
		}
	}
})
// export default store



// WEBPACK FOOTER //
// ./src/store/index.js